import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { getPublicConfig } from '../reducers';

Logo.propTypes = {
    className: PropTypes.string,
};

function Logo(props) {
    const {
        className = null,
    } = props;
    const publicConfig = useSelector(getPublicConfig);
    return (
        <NavLink to="/" className={className}>
            <img src={`data:image/png;base64,${publicConfig.logo}`} width={100} alt={publicConfig.customer} />
        </NavLink>
    );
}

export default Logo;
